<h1 *ngIf="vm.userBrandingSettings.length === 0">Loading...</h1>
<div class="container" *ngIf="vm.userBrandingSettings.length > 0">
  <div class="header flex row space-between">
    <div>Dashboard</div>
    <ichannel-button
      [callback]="vm.addNewSettingClicked.bind(vm)"
      [label]="'+ ADD NEW SETTING'"
      [theme]="'DARK'"
    ></ichannel-button>
  </div>

  <table class="dashboard-table">
    <thead>
      <tr>
        <th>Domain Name</th>
        <th class="actions">Actions</th>
      </tr>
    </thead>
    <tr *ngFor="let userBrandingSetting of vm.userBrandingSettings">
      <td [ngClass]="{'default-setting': userBrandingSetting.isDefault}">{{userBrandingSetting.domainNameAsUid}}</td>
      <td class="actions">
        <div class="buttons flex space-around"

        >
          <settings-button
            [hoverClass]="'hover-black'"
            (click)="vm.onSettingsButtonClicked(userBrandingSetting)"></settings-button>
          <remove-button
            [ngStyle]="{
            'visibility': userBrandingSetting.isDefault ? 'hidden' : 'visible'
            }"

            [overrideClass]="'hover-black'"
            (click)="vm.onDeleteButtonClicked(userBrandingSetting)"></remove-button>
        </div>

      </td>
    </tr>
  </table>
</div>
